export default __webpack_public_path__ + "static/media/higher_url_mark_reversed.9e36d662.svg";